export const DEFAULT_LOCALE = 'en-US'

export const SUPPORTED_LOCALES = ['en-US', 'lt-LT'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

/**
 * STO-3809: Maps merchant country codes to a supported UI locale.
 * Only country codes whose target locale is in SUPPORTED_LOCALES are listed —
 * unknown codes fall back to the browser-detected locale in I18nProvider.
 */
export const COUNTRY_TO_SUPPORTED_LOCALE: Partial<Record<string, SupportedLocale>> = {
	LT: 'lt-LT',
}
